module.exports = __webpack_public_path__ + "img/cp5-3.4978f495.jpg";